<template>
  <div>
    <transition name="slide-x-reverse-transition" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
</style>
